export const ALERT_ADD = 'ALERT_ADD';
export const ALERT_REMOVE = 'ALERT_REMOVE';

export const DANGER_ALERT_TYPE = 'danger';
export const SUCCESS_ALERT_TYPE = 'success';

export const NOTIFICATION_DELAY = 4000;